import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[ridangoFocusInvalidInput]'
})
export class FocusInvalidInputDirective {
  constructor(private el: ElementRef) {}

  @HostListener('submit')
  onFormSubmit(): void {
    const invalidControl = this.el.nativeElement.querySelector('.ng-invalid');

    if (invalidControl) {
        // checks if the native element is nested within ridango wrapper
        const elementRef = (invalidControl.querySelector('.ng-invalid')) || invalidControl;
        elementRef.focus();
    }
  }
}
